import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink, SocialIconLink, socialLinks } from './RedesignShell';

const contactRows = [
  { label: 'Телефон', value: '8 925 653 04 54', href: 'tel:+79256530454', note: 'Звонки: пн–пт 10:00–19:00' },
  { label: 'Email', value: 'fatality.digitalstudio@gmail.com', href: 'mailto:fatality.digitalstudio@gmail.com', note: '' },
  { label: 'Режим работы', value: 'Пн–Пт: 10:00 – 19:00; Сб–Вс: по предварительной договорённости', href: null, note: '' },
];

const directLinks = [
  {
    type: 'telegram',
    label: 'Telegram',
    href: socialLinks.telegram.href,
  },
  {
    type: 'max',
    label: 'Max',
    href: socialLinks.max.href,
  },
  {
    type: 'vk',
    label: 'ВКонтакте',
    href: socialLinks.vk.href,
  },
];

const channelLinks = [
  {
    type: 'telegram',
    label: 'Подписаться в Telegram',
    href: socialLinks.telegramChannel.href,
  },
  {
    type: 'vk',
    label: 'Подписаться',
    href: socialLinks.vkChannel.href,
  },
];

const requisites = [
  ['Название юр. лица', 'ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ ФАТАЛИЕВ ГИЯС ХАЗАР ОГЛЫ'],
  ['ИНН', '771819238234'],
  ['ОГРНИП', '322774600295323'],
  ['Юридический адрес', '107014, РОССИЯ, Г МОСКВА, УЛ ЖЕБРУНОВА, Д 2'],
];

const faqItems = [
  {
    question: 'Как быстро вы отвечаете на заявки?',
    answer: 'В течение 1 рабочего часа',
  },
  {
    question: 'Работаете с клиентами из других городов?',
    answer: 'Да, работаем удалённо по всей России',
  },
  {
    question: 'Можно ли приехать в офис?',
    answer: 'Да, по предварительной договоренности',
  },
  {
    question: 'Как проходит знакомство с проектом?',
    answer: 'Созвон 30 мин → бриф → коммерческое предложение',
  },
];

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Fatality Studio',
  telephone: '+79256530454',
  email: 'fatality.digitalstudio@gmail.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'УЛ ЖЕБРУНОВА, Д 2',
    addressLocality: 'МОСКВА',
    addressCountry: 'RU',
  },
  openingHours: 'Mo-Fr 10:00-19:00',
};

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function ContactsRedesignPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Контакты Fatality — digital-агентство в Москве | Телефон и адрес"
        description="Свяжитесь с digital-агентством Fatality: ☎ 8 925 653 04 54, Москва, ул. Жебрунова 2. Оставьте заявку — ответим в течение часа."
        structuredData={organizationJsonLd}
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid contacts-source-hero-grid">
          <div>
            <div className="eyebrow cyan">— контакты</div>
            <h1>Контакты Fatality Studio</h1>
            <p className="hero-sub">Обсудим любой Ваш проект или просто идею — ответим в течение 1 рабочего часа.</p>
            <div className="hero-ctas">
              <a href="tel:+79256530454" className="btn btn-primary">
                8 925 653 04 54
              </a>
              <SocialIconLink type="telegram" className="hero-social-link" label="Telegram" />
              <SocialIconLink type="max" className="hero-social-link" label="Max" />
            </div>
            <SiteLink href="#contacts-lead" className="btn btn-primary section-action">
              Оставить контакты
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— связь" title="Как с нами связаться" />
          <div className="price-list">
            {contactRows.map(({ label, value, href, note }) => (
              <div className="price-row price-row-three" key={label}>
                <h3 className="contact-row-heading">{label}</h3>
                <b>{href ? <a href={href}>{value}</a> : value}</b>
                <small>{note}</small>
              </div>
            ))}
            <div className="price-row price-row-three">
              <h3 className="contact-row-heading">Мессенджеры</h3>
              <b>
                <div className="contact-icon-strip" aria-label="Мессенджеры">
                  {directLinks.map((item) => (
                    <SocialIconLink type={item.type} label={item.label} href={item.href} key={item.type} />
                  ))}
                </div>
              </b>
              <small />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— офис" title="Офис в Москве" />
          <div className="case-media-layout">
            <div>
              <h3 className="standalone-h3">Адрес</h3>
              <p>Г. МОСКВА, УЛ ЖЕБРУНОВА, Д 2</p>
            </div>
            <div className="contact-map">
              <iframe
                title="Карта Яндекс.Карта с адресом"
                src="https://yandex.ru/map-widget/v1/?text=%D0%9C%D0%9E%D0%A1%D0%9A%D0%92%D0%90%2C%20%D0%A3%D0%9B%20%D0%96%D0%95%D0%91%D0%A0%D0%A3%D0%9D%D0%9E%D0%92%D0%90%2C%20%D0%94%202"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="contacts-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Оставьте заявку</h2>
              <p className="lead-text">Сообщите нам о заинтересованности — мы с радостью обсудим ваш проект</p>
            </div>
            <LeadForm
              formId="contacts-lead-form"
              idPrefix="contacts"
              contactLabel="Телефон"
              contactType="tel"
              contactPlaceholder="+7 (___) ___-__-__"
              showCompany={false}
              submitLabel="Оставить контакты"
              taskPlaceholder="Сообщите нам о заинтересованности"
            />
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— социальные сети" title="Мы в социальных сетях" />
          <div className="contact-social-compact">
            <div>
              <h3 className="standalone-h3">Написать напрямую</h3>
              <div className="contact-icon-strip social-row">
                {directLinks.map((item) => (
                  <SocialIconLink type={item.type} label={item.label} href={item.href} key={item.type} />
                ))}
              </div>
            </div>
            <div>
              <h3 className="standalone-h3">Каналы агентства</h3>
              <div className="contact-icon-strip social-row">
                {channelLinks.map((item) => (
                  <SocialIconLink type={item.type} label={item.label} href={item.href} key={item.href} />
                ))}
              </div>
            </div>
          </div>
          <div className="contact-rating-link">
            <SiteLink
              href="http://vc.ru/%D0%B4%D0%B7%D0%B5%D0%BD"
              className="link-flat"
              target="_blank"
              rel="noreferrer"
            >
              vc.ru/дзен
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— реквизиты" title="Реквизиты" />
          <div className="price-list">
            {requisites.map(([label, value]) => (
              <div className="price-row price-row-three" key={label}>
                <span>{label}</span>
                <small>{value}</small>
                <b />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Часто задаваемые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <button className="faq-q" type="button" onClick={() => setOpenFaq(isOpen ? -1 : index)}>
                      <span>{item.question}</span>
                      <span className="faq-toggle">+</span>
                    </button>
                    <div className="faq-a">
                      <div className="faq-a-inner">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default ContactsRedesignPage;
